import { NotaVersaoUsuario } from './_models'

/** Telas de atendimento em curso (vídeo): a nota espera a próxima navegação para fora delas. */
const ROTAS_DE_ATENDIMENTO = [
  '/apps/atendimentos/teleAtendimento',
  '/apps/atendimentosMedicos/teleAtendimento',
]

export const ehRotaDeAtendimentoEmCurso = (pathname: string): boolean =>
  ROTAS_DE_ATENDIMENTO.some((rota) => pathname === rota || pathname.startsWith(`${rota}/`))

const chaveAdiamento = (idUsuario: number, idNota: number) =>
  `notaVersao:adiada:${idUsuario}:${idNota}`

/** "Ler depois" vale até o fim da sessão do navegador, por usuário e por nota. */
export const marcarAdiadaNaSessao = (idUsuario: number, idNota: number): void => {
  try {
    sessionStorage.setItem(chaveAdiamento(idUsuario, idNota), '1')
  } catch {
    // Storage indisponível (modo privado restrito): o pior caso é reabrir na próxima carga.
  }
}

export const foiAdiadaNaSessao = (idUsuario: number, idNota: number): boolean => {
  try {
    return sessionStorage.getItem(chaveAdiamento(idUsuario, idNota)) !== null
  } catch {
    return false
  }
}

/** NENHUMA abre; ADIADA só abre se não foi adiada nesta sessão; LIDA ou sem vigente, nunca. */
export const deveAbrirNotaVigente = (
  nota: Pick<NotaVersaoUsuario, 'situacao'> | null | undefined,
  adiadaNestaSessao: boolean
): boolean => {
  if (!nota) return false
  if (nota.situacao === 'NENHUMA') return true
  return nota.situacao === 'ADIADA' && !adiadaNestaSessao
}
